import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

// https://portfolio-api-yey0.onrender.com/
// http://localhost:3005
